jQuery(($) => {
    $('[data-carousel-container]').each(function () {
        let _carousel = this;
        var $carousel = $(_carousel);
        var name = $carousel.data('carousel-container');
        var $items = $('[data-carousel-item="' + name + '"]');
        var $prev = $('[data-carousel-prev="' + name + '"]');
        var $next = $('[data-carousel-next="' + name + '"]');
        var $dots = $('[data-carousel-dots="' + name + '"]');

        function setControlVisibility(value) {
            var func = value ? 'show' : 'hide';
            $prev[func]();
            $next[func]();
            $dots[func]();
        }

        function scrollToItem(itemNum) {
            var _target = $items[itemNum];
            if(!_target) _target = $items.last()[0];

            var firstPos = $items.first()[0].getBoundingClientRect().left;
            var positions = [];
            $items.each(function() {
                var position = this.getBoundingClientRect().left;
                positions.push(position - firstPos);
            });

            var width = $carousel.innerWidth();
            var maxX = ($items.last()[0].getBoundingClientRect().right - firstPos) - width;
            
            var targetX = positions[Math.min(itemNum, positions.length - 1)];
            if (targetX > maxX) targetX = maxX;

            $items.first().css('margin-left', -targetX + 'px');
            
            if (targetX > 0) $prev.removeAttr('disabled');
            else $prev.attr('disabled', '');

            if (targetX === maxX) $next.attr('disabled', '');
            else $next.removeAttr('disabled');

            $dots.children().removeClass('active').eq(itemNum).addClass('active');
        }

        function currentItem() {
            var numLeft = 0;
            var minX = _carousel.getBoundingClientRect().left;
            $items.each(function() {
                if (this.getBoundingClientRect().left < minX) numLeft++;
            });
            return numLeft;
        }

        function next() {
            scrollToItem(currentItem() + 1);
        }

        function prev() {
            scrollToItem(currentItem() - 1);
        }

        function updateDots() {
            var elementName = $dots.data('carousel-dot-element') || 'div';
            var className = $dots.data('carousel-dot-class') || 'carousel__dot';

            let index = 0;
            $dots.empty();
            $('<' + elementName + '>').on('click', scrollToItem.bind(null, index++)).addClass(className + ' active').appendTo($dots);
            var maxX = _carousel.getBoundingClientRect().right;
            $items.each(function() {
                if (this.getBoundingClientRect().right > maxX) {
                    $('<' + elementName + '>').on('click', scrollToItem.bind(null, index++)).addClass(className).appendTo($dots);
                }
            });
        }

        function update() {
            scrollToItem(0);
            var maxWidth = $carousel.width();
            var numItems = $items.length;
            if (!numItems) return setControlVisibility(false);

            var maxX = _carousel.getBoundingClientRect().right;
            var lastX = $items.last()[0].getBoundingClientRect().right;
            var scrollable = lastX >= maxX;
            setControlVisibility(scrollable);

            if (scrollable) {
                updateDots();
            }
        }

        $next.on('click', next);
        $prev.on('click', prev);
        $(window).on('resize', update);
        update();
    });
});
